/**
 * The server's own message for a 4xx from `/api/import/extract` — e.g. the PDF
 * "use Paste" hint (415), "save as CSV" (413), unsupported type, or a rate
 * limit — or null for 5xx / unreadable bodies, where the caller's generic copy
 * is the right thing to show. The route only ever puts user-facing copy in
 * `error`; it is rendered as React children (auto-escaped).
 */
export async function clientErrorMessage(res: Response): Promise<string | null> {
	if (res.status < 400 || res.status >= 500) return null
	const body = (await res.json().catch(() => null)) as { error?: unknown } | null
	const message = body?.error
	return typeof message === 'string' && message.length > 0 && message.length <= 300 ? message : null
}
